interface AIScoresCardProps {
  preparation: number;
  execution: number;
  completion: number;
  overall: number;
}

function AIScoresCard({
  preparation,
  execution,
  completion,
  overall,
}: AIScoresCardProps) {
  return (
 <section>
      <h3 className="sidebar-heading">
        AI SUGGESTED SCORE
      </h3>

      <div className="info-grid info-grid--3">
        <div className="info-card">
          <span className="info-label">Preparation</span>
          <strong className="info-value-small">
            {preparation}/5
          </strong>
        </div>

        <div className="info-card">
          <span className="info-label">Execution</span>
          <strong className="info-value-small">
            {execution}/5
          </strong>
        </div>

        <div className="info-card">
          <span className="info-label">Completion</span>
          <strong className="info-value-small">
            {completion}/5
          </strong>
        </div>
      </div>

      <div className="overall-score-card">
        <span className="overall-score-label">
          Overall Score
        </span>

        <strong className="overall-score-value">
          {overall}/5
        </strong>
      </div>
    </section>
  );
}

export default AIScoresCard;